import React, {useCallback} from 'react'
import {useSelector} from 'react-redux'
import {ProfileKey} from '@findhotel/sapi/dist/types/packages/core/src'
import {GoogleOneTapWrapper} from 'components/GoogleOneTapWrapper'
import Layout from 'components/Layouts'
import TrackPageView from 'components/TrackPageView'
import {useSyncStoreWithUrl} from 'hooks/useSyncStoreWithUrl'
import {useTrackServerSearch} from 'hooks/useTrackServerSearch'
import {getSapiMetaOptions} from 'modules/meta/selectors'
import {SapiProvider} from 'modules/sapiSearch/SapiProvider'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import InjectPageDataId from '@vio/core/src/analytics/components/InjectPageDataId'
import {Page} from '@vio/core/src/analytics/types/Events'
import {getDataFile} from '@vio/core/src/experiments/modules/selectors'
import {collectSapiVariationsParam} from '@vio/core/src/experiments/sapi'

import {SearchViewContainer as Search} from './Search'

const SyncStore = () => {
  useSyncStoreWithUrl({disallowInvalidSearchParams: true})
  return null
}

const SearchView: React.FC = () => {
  const sapiMetaOptions = useSelector(getSapiMetaOptions)
  const dataFile = useSelector(getDataFile) as {
    featureFlags: Array<{key: string}>
  }

  const {search} = useBrandCapabilities()

  useTrackServerSearch()

  const generateOptions = useCallback(
    () => ({
      ...sapiMetaOptions,
      pageSize: Number(process.env.NEXT_PUBLIC_SEARCH_PAGE_SIZE),
      variations: collectSapiVariationsParam(
        // TODO: @votsa: Opticks should expose Optimisely's getEnabledFeatures method
        // to retrieve only enabled experiments
        // instead of reading all featureFlags from datafile
        // https://github.com/FindHotel/opticks/pull/46
        dataFile?.featureFlags.map(({key}) => key)
      )
    }),
    [sapiMetaOptions, dataFile]
  )

  return (
    <>
      <SyncStore />
      <TrackPageView pageName={Page.Search} />
      <InjectPageDataId page={Page.Search} />

      <SapiProvider
        profileKey={process.env.NEXT_PUBLIC_SAPI_PROFILE_KEY as ProfileKey}
        generateOptions={generateOptions}
      >
        <Layout
          hasFilters={search.hasFilters}
          hasSearchForm
          hasHeaderDividerOnMobile
          hasHeaderOnMobile
          hasFooterOnMobile={false}
          hasHeaderSearchSummary
          hasSearchProgressBar
          page={Page.Search}
        >
          <Search />
        </Layout>
      </SapiProvider>
      <GoogleOneTapWrapper />
    </>
  )
}

const SearchViewMemo = React.memo(SearchView)
export default SearchViewMemo
